import { copyToClipboard, Notify } from 'quasar'

export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms))
}

/**
 * Efficiently encodes a Uint8Array to a base64 string.
 */
export function base64Encode(bytes: Uint8Array): string {
  let binary = ''
  const len = bytes.length
  const chunkSize = 0x80_00 // 32KB chunks to avoid stack overflow
  for (let i = 0; i < len; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize)
    binary += String.fromCodePoint(...chunk)
  }
  return btoa(binary)
}

export function clickOnElement(elClass: string) {
  const element = document.querySelector(elClass) as HTMLElement
  if (element) {
    element.click()
  }
}

export function copy(text: string) {
  copyToClipboard(text)
  Notify.create({
    message: 'Copied',
  })
}
